import React, { useState } from "react";
import {Box, useTheme} from "@mui/material";
import { tokens } from "../../theme";
import { updatePixel, selectPixel } from "../../slices/sign_image_editor"
import { useDispatch, useSelector ,shallowEqual} from "react-redux";

const getPixelIndex = (row,column,width) =>{

  let index = (row * width) + column;

  return index; 
}

const Pixel = (props) => {

  const theme = useTheme()
  const colors = tokens(theme.palette.mode);

  const dispatch = useDispatch();

  const {row,column, width, pixelSize} = props;

  const selectedColor = useSelector((state) => state.imageEditor.selectedColor, shallowEqual)
  const selectedTool = useSelector((state) => state.imageEditor.selectedTool, shallowEqual)
  const selectedFrame = useSelector((state) => state.imageEditor.selectedFrame, shallowEqual)

  const pixelIndex = getPixelIndex(row,column,width);

  const pixelBackground = useSelector((state) => selectPixel(state,selectedFrame,pixelIndex),shallowEqual);

  let colourToUse = selectedColor;
  let cursor = "default"

  if (selectedTool === "eraser")
  {
    colourToUse = "#000000";
    cursor = "context-menu"
  }

  if (selectedTool === "picker")
  {
    cursor = "copy"
  }

  if (selectedTool === "brush")
  {
    colourToUse = selectedColor;
    cursor = "crosshair"
  }

  if (selectedTool === "move")
  {
    cursor = "move"
  }

  if (selectedTool === "fill")
  {
    colourToUse = selectedColor;
    cursor = "crosshair"
  }




  //const [pixelColor, setPixelColor] = useState(`#${pixelBackground}`);

    const updateFramePixel = () => {

      let update = {
        frame: selectedFrame,
        pixelIndex: pixelIndex,
        row: row,
        column: column,
        color: colourToUse,
      }

      dispatch(updatePixel({update})); 

    }


  function applyColor() {
    updateFramePixel()
    //setPixelColor(colourToUse)
  }

  function checkApply(e) {

    
    if (e.button == 0 && e.buttons > 0){
      //Mouse left the pixel with the left button down to we set the colour
      updateFramePixel();
      //setPixelColor(colourToUse)
    }

  }

  return (

    <Box
      backgroundColor = {`#${pixelBackground}`}
      height = {pixelSize}
      width = {pixelSize}
      onClick={applyColor}
      onTouchStart={applyColor}
      //onMouseEnter={changeColorOnHover}
      onMouseEnter={checkApply}
      onMouseDown={checkApply}
      //onMouseUp={applyColor}
      sx={{ cursor: `${cursor}` , border: `.1pt solid ${colors.primary[400]}`, borderWidth: "0 1px 1px 0"}}
    />

  );
}

export default Pixel